/**
 * @fileoverview GET handler for the "/apps/catalog_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsCatalogFields } from "./constants";
import type { AppsCatalogFieldsParams, AppsCatalogFieldsResult } from "./types";

export const getAppsCatalogFields = reactQueryFetcherAdapter(
  appsCatalogFields,
  (signal: AbortSignal, params: AppsCatalogFieldsParams): Promise<AppsCatalogFieldsResult> => {
    return fetch("/apps/catalog_fields", "GET", params, { signal });
  }
);
